// extracted by mini-css-extract-plugin
export default {"container":"Y0-z","list":"Z0-z"};